import Vue from "vue";

export default {
  setOptionsData(state, payload) {
    Vue.set(state, "options", Object.assign(state.options, payload));
    //state.options = Object.assign(state[payload.name], payload)
  }
};
